// Stock/default cover images offered in the cash-fund image carousel (Add + Edit dialogs).
//
// These are FE-owned asset URLs on Joy's first-party host — a cash-fund default has
// no photo_service Photo id, so it flows through the mutation's `imageUrlForImport`
// (a.k.a. `photoUrl`) path exactly like the single legacy default always has.
//
// Hosted at s3://joy-public-assets-bucket/apps/registry/ (served via CloudFront at the
// URLs below). To add/replace: upload the .jpg to that prefix — see NREG-3006 / NREG-617.

import type { CashFundCoverImage } from './cashFundDefaultImages.types';

const ASSET_BASE = 'https://withjoy.com/assets/public/apps/registry';

export const CASH_FUND_DEFAULT_IMAGE = `${ASSET_BASE}/cash_fund_default_image.jpg`;
export const CHARITY_FUND_DEFAULT_IMAGE = `${ASSET_BASE}/charity_fund_default_image.jpg`;

// The canonical default (the pig) MUST stay first so a brand-new fund still seeds to it.
//
// Ordering is deliberately theme-interleaved: no two images from the same cluster
// (travel / home / plants / sky) sit adjacent, and near-duplicates (the three
// tropicals, the two seedlings, bluesky↔sky1, stucco↔floorboards) are spread far
// apart. The carousel loops, so the final entry is treated as adjacent to the pig.
export const CASH_FUND_DEFAULT_IMAGES: ReadonlyArray<CashFundCoverImage> = [
  { url: CASH_FUND_DEFAULT_IMAGE }, // pig (default)
  { url: `${ASSET_BASE}/cash_fund_tropical1.jpg` }, // travel
  { url: `${ASSET_BASE}/cash_fund_plants_seedling1.jpg` }, // plants
  { url: `${ASSET_BASE}/cash_fund_house.jpg` }, // home
  { url: `${ASSET_BASE}/cash_fund_plane.jpg` }, // travel
  { url: `${ASSET_BASE}/cash_fund_bluesky.jpg` }, // sky
  { url: `${ASSET_BASE}/cash_fund_plants_lush.jpg` }, // plants
  { url: `${ASSET_BASE}/cash_fund_beach1.jpg` }, // travel
  { url: `${ASSET_BASE}/cash_fund_stucco_shadows.jpg` }, // home
  { url: `${ASSET_BASE}/cash_fund_tropical2.jpg` }, // travel
  { url: `${ASSET_BASE}/cash_fund_flowers1.jpg` }, // plants
  { url: `${ASSET_BASE}/cash_fund_snowy_forest.jpg` }, // sky
  { url: `${ASSET_BASE}/cash_fund_road.jpg` }, // travel
  { url: `${ASSET_BASE}/cash_fund_homeimprovement.jpg` }, // home
  { url: `${ASSET_BASE}/cash_fund_car.jpg` }, // travel
  { url: `${ASSET_BASE}/cash_fund_plants_seedling2.jpg` }, // plants
  { url: `${ASSET_BASE}/cash_fund_tropical3.jpg` }, // travel
  { url: `${ASSET_BASE}/cash_fund_sky1.jpg` }, // sky
  { url: `${ASSET_BASE}/cash_fund_floorboards.jpg` }, // home
  { url: `${ASSET_BASE}/cash_fund_luggage.jpg` }, // travel
];

// No charity-specific stock set was provided yet, so charity funds keep just their
// single default (the carousel hides itself for a one-image set).
export const CHARITY_FUND_DEFAULT_IMAGES: ReadonlyArray<CashFundCoverImage> = [{ url: CHARITY_FUND_DEFAULT_IMAGE }];

export const getDefaultCoverImages = (isCharityFund: boolean): ReadonlyArray<CashFundCoverImage> => (isCharityFund ? CHARITY_FUND_DEFAULT_IMAGES : CASH_FUND_DEFAULT_IMAGES);
